// SEO metadata for each page
export const seoData = {
  home: {
    title: 'Web Growth Studio | Web Design & Social Media',
    description: 'Transform your online presence with Web Growth Studio. Custom website design, development, and social media management for businesses.',
    keywords: 'web design, website development, social media management, Instagram marketing, Facebook ads, website redesign, digital marketing agency',
    url: 'https://webgrowthstudio.com'
  },
  about: {
    title: 'About Us | Web Growth Studio Team',
    description: 'Meet the Web Growth Studio team: Dunja, Sava, and Marko. We are passionate digital professionals dedicated to helping businesses thrive online through web design and social media.',
    keywords: 'web design team, digital agency team, about web growth studio, professional web designers',
    url: 'https://webgrowthstudio.com/about'
  },
  services: {
    title: 'Our Services | Web Design & Social Media Management',
    description: 'Web Growth Studio offers comprehensive digital services: custom website design, website redesign, Instagram management, Facebook marketing, and social media setup. Contact us for pricing.',
    keywords: 'web design services, website development services, social media management services, Instagram marketing, Facebook ads, website redesign services',
    url: 'https://webgrowthstudio.com/services'
  },
  portfolio: {
    title: 'Portfolio | Our Recent Web Design Projects',
    description: 'View our portfolio of successful web design and development projects including MixTV, IPTV HQ, Want2 Travel, and Donna Puo. See our work and get inspired for your project.',
    keywords: 'web design portfolio, website examples, web development projects, portfolio websites, digital agency work',
    url: 'https://webgrowthstudio.com/portfolio'
  },
  contact: {
    title: 'Contact Us | Get Your Free Consultation',
    description: 'Ready to grow your business online? Contact Web Growth Studio for a free consultation. We specialize in web design, development, and social media management. Get started today!',
    keywords: 'contact web designer, free consultation, web design quote, social media management inquiry, hire web designer',
    url: 'https://webgrowthstudio.com/contact'
  }
};
